var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductVariants({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,3.5C9,2.7,8.3,2,7.5,2h-4C2.7,2,2,2.7,2,3.5v31C2,35.3,2.7,36,3.5,36h4C8.3,36,9,35.3,9,34.5V3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,3.5C50,2.7,49.3,2,48.5,2h-4C43.7,2,43,2.7,43,3.5v31c0,0.8,0.7,1.5,1.5,1.5h4c0.8,0,1.5-0.7,1.5-1.5 V3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,2h-3C33.7,2,33,2.8,33,3.6V16c0,0.4,0.2,0.7,0.6,0.9c1.7,0.9,3.2,2,4.5,3.3c0.3,0.3,0.9,0.1,0.9-0.3 V3.6C39,2.8,38.3,2,37.5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1,15.2c0.6-0.1,1.3-0.1,1.9-0.1s1.3,0,1.9,0.1s1.1-0.4,1.1-1V3.6C29,2.8,28.3,2,27.5,2h-3 C23.7,2,23,2.8,23,3.6v10.6C23,14.8,23.5,15.3,24.1,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9,20.2c1.3-1.4,2.9-2.5,4.6-3.3c0.3-0.2,0.5-0.5,0.5-0.9V3.6C19,2.8,18.3,2,17.5,2h-3 C13.7,2,13,2.8,13,3.6v16.3C13,20.3,13.5,20.5,13.9,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,19.1c-7.2,0-13,5.8-13,13c0,2.2,0.6,4.4,1.6,6.2l-7.1,7.1c-0.6,0.6-0.6,1.5,0,2.1l2.1,2.1 c0.6,0.6,1.5,0.6,2.1,0l6.9-6.9c2.1,1.5,4.7,2.4,7.4,2.4c7.2,0,13-5.8,13-13S33.2,19.1,26,19.1z M26,39.1c-3.9,0-7-3.1-7-7 s3.1-7,7-7s7,3.1,7,7S29.9,39.1,26,39.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductVariants);
export default __webpack_public_path__ + "static/media/product-variants.dadc823a88fb59e2b60c22063e00ce80.svg";
export { ForwardRef as ReactComponent };